/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as PlainRouteImport } from './routes/plain'
import { Route as AccessDeniedRouteImport } from './routes/access-denied'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthNotAuthorizedRouteImport } from './routes/_auth/not-authorized'
import { Route as AuthLoginSuccessRouteImport } from './routes/_auth/login-success'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppBackendSettingsBarcodeRouteImport } from './routes/_app/backend-settings/barcode'
import { Route as AppAppSettingsLiveRouteImport } from './routes/_app/app-settings/live'
import { Route as AppInventoryVendorIndexRouteImport } from './routes/_app/inventory/vendor/index'
import { Route as AppInventoryPurchaseOrderIndexRouteImport } from './routes/_app/inventory/purchase-order/index'
import { Route as AppInventoryCategoryIndexRouteImport } from './routes/_app/inventory/category/index'
import { Route as AppBackendSettingsProductImportIndexRouteImport } from './routes/_app/backend-settings/product-import/index'
import { Route as AppInventorySalesOrderModalRouteImport } from './routes/_app/inventory/sales-order/_modal'
import { Route as AppInventoryProductModalRouteImport } from './routes/_app/inventory/product/_modal'
import { Route as AppInventoryProductModelModalRouteImport } from './routes/_app/inventory/product-model/_modal'
import { Route as AppInventoryLiveModalRouteImport } from './routes/_app/inventory/live/_modal'
import { Route as AppInventoryDealsModalRouteImport } from './routes/_app/inventory/deals/_modal'
import { Route as AppInventoryCustomerModalRouteImport } from './routes/_app/inventory/customer/_modal'
import { Route as AppBackendSettingsAddressPhRouteImport } from './routes/_app/backend-settings/address/ph'
import { Route as AppBackendSettingsAddressJpRouteImport } from './routes/_app/backend-settings/address/jp'
import { Route as AppInventorySalesOrderModalIndexRouteImport } from './routes/_app/inventory/sales-order/_modal.index'
import { Route as AppInventoryProductModalIndexRouteImport } from './routes/_app/inventory/product/_modal.index'
import { Route as AppInventoryProductModelModalIndexRouteImport } from './routes/_app/inventory/product-model/_modal.index'
import { Route as AppInventoryLiveModalIndexRouteImport } from './routes/_app/inventory/live/_modal.index'
import { Route as AppInventoryDealsModalIndexRouteImport } from './routes/_app/inventory/deals/_modal.index'
import { Route as AppInventoryCustomerModalIndexRouteImport } from './routes/_app/inventory/customer/_modal.index'
import { Route as AppInventorySalesOrderModalWarehouseRouteImport } from './routes/_app/inventory/sales-order/_modal.warehouse'
import { Route as AppInventorySalesOrderModalPaymentsRouteImport } from './routes/_app/inventory/sales-order/_modal.payments'
import { Route as AppInventorySalesOrderModalLogisticRouteImport } from './routes/_app/inventory/sales-order/_modal.logistic'
import { Route as AppInventorySalesOrderModalAppRouteImport } from './routes/_app/inventory/sales-order/_modal.app'
import { Route as AppInventorySalesOrderModalSalesOrderIdRouteImport } from './routes/_app/inventory/sales-order/_modal.$salesOrderId'
import { Route as AppInventoryPurchaseOrderSupplierImportPageRouteImport } from './routes/_app/inventory/purchase-order/supplier-import/page'

const AppInventorySalesOrderRouteImport = createFileRoute(
  '/_app/inventory/sales-order',
)()
const AppInventoryProductRouteImport = createFileRoute(
  '/_app/inventory/product',
)()
const AppInventoryProductModelRouteImport = createFileRoute(
  '/_app/inventory/product-model',
)()
const AppInventoryLiveRouteImport = createFileRoute('/_app/inventory/live')()
const AppInventoryDealsRouteImport = createFileRoute('/_app/inventory/deals')()
const AppInventoryCustomerRouteImport = createFileRoute(
  '/_app/inventory/customer',
)()

const PlainRoute = PlainRouteImport.update({
  id: '/plain',
  path: '/plain',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessDeniedRoute = AccessDeniedRouteImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthNotAuthorizedRoute = AuthNotAuthorizedRouteImport.update({
  id: '/not-authorized',
  path: '/not-authorized',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginSuccessRoute = AuthLoginSuccessRouteImport.update({
  id: '/login-success',
  path: '/login-success',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppInventorySalesOrderRoute = AppInventorySalesOrderRouteImport.update({
  id: '/inventory/sales-order',
  path: '/inventory/sales-order',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryProductRoute = AppInventoryProductRouteImport.update({
  id: '/inventory/product',
  path: '/inventory/product',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryProductModelRoute =
  AppInventoryProductModelRouteImport.update({
    id: '/inventory/product-model',
    path: '/inventory/product-model',
    getParentRoute: () => AppRoute,
  } as any)
const AppInventoryLiveRoute = AppInventoryLiveRouteImport.update({
  id: '/inventory/live',
  path: '/inventory/live',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryDealsRoute = AppInventoryDealsRouteImport.update({
  id: '/inventory/deals',
  path: '/inventory/deals',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryCustomerRoute = AppInventoryCustomerRouteImport.update({
  id: '/inventory/customer',
  path: '/inventory/customer',
  getParentRoute: () => AppRoute,
} as any)
const AppBackendSettingsBarcodeRoute =
  AppBackendSettingsBarcodeRouteImport.update({
    id: '/backend-settings/barcode',
    path: '/backend-settings/barcode',
    getParentRoute: () => AppRoute,
  } as any)
const AppAppSettingsLiveRoute = AppAppSettingsLiveRouteImport.update({
  id: '/app-settings/live',
  path: '/app-settings/live',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryVendorIndexRoute = AppInventoryVendorIndexRouteImport.update({
  id: '/inventory/vendor/',
  path: '/inventory/vendor/',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryPurchaseOrderIndexRoute =
  AppInventoryPurchaseOrderIndexRouteImport.update({
    id: '/inventory/purchase-order/',
    path: '/inventory/purchase-order/',
    getParentRoute: () => AppRoute,
  } as any)
const AppInventoryCategoryIndexRoute =
  AppInventoryCategoryIndexRouteImport.update({
    id: '/inventory/category/',
    path: '/inventory/category/',
    getParentRoute: () => AppRoute,
  } as any)
const AppBackendSettingsProductImportIndexRoute =
  AppBackendSettingsProductImportIndexRouteImport.update({
    id: '/backend-settings/product-import/',
    path: '/backend-settings/product-import/',
    getParentRoute: () => AppRoute,
  } as any)
const AppInventorySalesOrderModalRoute =
  AppInventorySalesOrderModalRouteImport.update({
    id: '/_modal',
    getParentRoute: () => AppInventorySalesOrderRoute,
  } as any)
const AppInventoryProductModalRoute =
  AppInventoryProductModalRouteImport.update({
    id: '/_modal',
    getParentRoute: () => AppInventoryProductRoute,
  } as any)
const AppInventoryProductModelModalRoute =
  AppInventoryProductModelModalRouteImport.update({
    id: '/_modal',
    getParentRoute: () => AppInventoryProductModelRoute,
  } as any)
const AppInventoryLiveModalRoute = AppInventoryLiveModalRouteImport.update({
  id: '/_modal',
  getParentRoute: () => AppInventoryLiveRoute,
} as any)
const AppInventoryDealsModalRoute = AppInventoryDealsModalRouteImport.update({
  id: '/_modal',
  getParentRoute: () => AppInventoryDealsRoute,
} as any)
const AppInventoryCustomerModalRoute =
  AppInventoryCustomerModalRouteImport.update({
    id: '/_modal',
    getParentRoute: () => AppInventoryCustomerRoute,
  } as any)
const AppBackendSettingsAddressPhRoute =
  AppBackendSettingsAddressPhRouteImport.update({
    id: '/backend-settings/address/ph',
    path: '/backend-settings/address/ph',
    getParentRoute: () => AppRoute,
  } as any)
const AppBackendSettingsAddressJpRoute =
  AppBackendSettingsAddressJpRouteImport.update({
    id: '/backend-settings/address/jp',
    path: '/backend-settings/address/jp',
    getParentRoute: () => AppRoute,
  } as any)
const AppInventorySalesOrderModalIndexRoute =
  AppInventorySalesOrderModalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppInventorySalesOrderModalRoute,
  } as any)
const AppInventoryProductModalIndexRoute =
  AppInventoryProductModalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppInventoryProductModalRoute,
  } as any)
const AppInventoryProductModelModalIndexRoute =
  AppInventoryProductModelModalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppInventoryProductModelModalRoute,
  } as any)
const AppInventoryLiveModalIndexRoute =
  AppInventoryLiveModalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppInventoryLiveModalRoute,
  } as any)
const AppInventoryDealsModalIndexRoute =
  AppInventoryDealsModalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppInventoryDealsModalRoute,
  } as any)
const AppInventoryCustomerModalIndexRoute =
  AppInventoryCustomerModalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppInventoryCustomerModalRoute,
  } as any)
const AppInventorySalesOrderModalWarehouseRoute =
  AppInventorySalesOrderModalWarehouseRouteImport.update({
    id: '/warehouse',
    path: '/warehouse',
    getParentRoute: () => AppInventorySalesOrderModalRoute,
  } as any)
const AppInventorySalesOrderModalPaymentsRoute =
  AppInventorySalesOrderModalPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AppInventorySalesOrderModalRoute,
  } as any)
const AppInventorySalesOrderModalLogisticRoute =
  AppInventorySalesOrderModalLogisticRouteImport.update({
    id: '/logistic',
    path: '/logistic',
    getParentRoute: () => AppInventorySalesOrderModalRoute,
  } as any)
const AppInventorySalesOrderModalAppRoute =
  AppInventorySalesOrderModalAppRouteImport.update({
    id: '/app',
    path: '/app',
    getParentRoute: () => AppInventorySalesOrderModalRoute,
  } as any)
const AppInventorySalesOrderModalSalesOrderIdRoute =
  AppInventorySalesOrderModalSalesOrderIdRouteImport.update({
    id: '/$salesOrderId',
    path: '/$salesOrderId',
    getParentRoute: () => AppInventorySalesOrderModalRoute,
  } as any)
const AppInventoryPurchaseOrderSupplierImportPageRoute =
  AppInventoryPurchaseOrderSupplierImportPageRouteImport.update({
    id: '/inventory/purchase-order/supplier-import/page',
    path: '/inventory/purchase-order/supplier-import/page',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/access-denied': typeof AccessDeniedRoute
  '/plain': typeof PlainRoute
  '/account': typeof AppAccountRoute
  '/admin': typeof AppAdminRoute
  '/dashboard': typeof AppDashboardRoute
  '/login': typeof AuthLoginRoute
  '/login-success': typeof AuthLoginSuccessRoute
  '/not-authorized': typeof AuthNotAuthorizedRoute
  '/': typeof AppIndexRoute
  '/app-settings/live': typeof AppAppSettingsLiveRoute
  '/backend-settings/barcode': typeof AppBackendSettingsBarcodeRoute
  '/backend-settings/address/jp': typeof AppBackendSettingsAddressJpRoute
  '/backend-settings/address/ph': typeof AppBackendSettingsAddressPhRoute
  '/inventory/customer': typeof AppInventoryCustomerModalRouteWithChildren
  '/inventory/deals': typeof AppInventoryDealsModalRouteWithChildren
  '/inventory/live': typeof AppInventoryLiveModalRouteWithChildren
  '/inventory/product-model': typeof AppInventoryProductModelModalRouteWithChildren
  '/inventory/product': typeof AppInventoryProductModalRouteWithChildren
  '/inventory/sales-order': typeof AppInventorySalesOrderModalRouteWithChildren
  '/backend-settings/product-import': typeof AppBackendSettingsProductImportIndexRoute
  '/inventory/category': typeof AppInventoryCategoryIndexRoute
  '/inventory/purchase-order': typeof AppInventoryPurchaseOrderIndexRoute
  '/inventory/vendor': typeof AppInventoryVendorIndexRoute
  '/inventory/purchase-order/supplier-import/page': typeof AppInventoryPurchaseOrderSupplierImportPageRoute
  '/inventory/sales-order/$salesOrderId': typeof AppInventorySalesOrderModalSalesOrderIdRoute
  '/inventory/sales-order/app': typeof AppInventorySalesOrderModalAppRoute
  '/inventory/sales-order/logistic': typeof AppInventorySalesOrderModalLogisticRoute
  '/inventory/sales-order/payments': typeof AppInventorySalesOrderModalPaymentsRoute
  '/inventory/sales-order/warehouse': typeof AppInventorySalesOrderModalWarehouseRoute
  '/inventory/customer/': typeof AppInventoryCustomerModalIndexRoute
  '/inventory/deals/': typeof AppInventoryDealsModalIndexRoute
  '/inventory/live/': typeof AppInventoryLiveModalIndexRoute
  '/inventory/product-model/': typeof AppInventoryProductModelModalIndexRoute
  '/inventory/product/': typeof AppInventoryProductModalIndexRoute
  '/inventory/sales-order/': typeof AppInventorySalesOrderModalIndexRoute
}
export interface FileRoutesByTo {
  '/access-denied': typeof AccessDeniedRoute
  '/plain': typeof PlainRoute
  '/account': typeof AppAccountRoute
  '/admin': typeof AppAdminRoute
  '/dashboard': typeof AppDashboardRoute
  '/login': typeof AuthLoginRoute
  '/login-success': typeof AuthLoginSuccessRoute
  '/not-authorized': typeof AuthNotAuthorizedRoute
  '/': typeof AppIndexRoute
  '/app-settings/live': typeof AppAppSettingsLiveRoute
  '/backend-settings/barcode': typeof AppBackendSettingsBarcodeRoute
  '/backend-settings/address/jp': typeof AppBackendSettingsAddressJpRoute
  '/backend-settings/address/ph': typeof AppBackendSettingsAddressPhRoute
  '/inventory/customer': typeof AppInventoryCustomerModalIndexRoute
  '/inventory/deals': typeof AppInventoryDealsModalIndexRoute
  '/inventory/live': typeof AppInventoryLiveModalIndexRoute
  '/inventory/product-model': typeof AppInventoryProductModelModalIndexRoute
  '/inventory/product': typeof AppInventoryProductModalIndexRoute
  '/inventory/sales-order': typeof AppInventorySalesOrderModalIndexRoute
  '/backend-settings/product-import': typeof AppBackendSettingsProductImportIndexRoute
  '/inventory/category': typeof AppInventoryCategoryIndexRoute
  '/inventory/purchase-order': typeof AppInventoryPurchaseOrderIndexRoute
  '/inventory/vendor': typeof AppInventoryVendorIndexRoute
  '/inventory/purchase-order/supplier-import/page': typeof AppInventoryPurchaseOrderSupplierImportPageRoute
  '/inventory/sales-order/$salesOrderId': typeof AppInventorySalesOrderModalSalesOrderIdRoute
  '/inventory/sales-order/app': typeof AppInventorySalesOrderModalAppRoute
  '/inventory/sales-order/logistic': typeof AppInventorySalesOrderModalLogisticRoute
  '/inventory/sales-order/payments': typeof AppInventorySalesOrderModalPaymentsRoute
  '/inventory/sales-order/warehouse': typeof AppInventorySalesOrderModalWarehouseRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/access-denied': typeof AccessDeniedRoute
  '/plain': typeof PlainRoute
  '/_app/account': typeof AppAccountRoute
  '/_app/admin': typeof AppAdminRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/login-success': typeof AuthLoginSuccessRoute
  '/_auth/not-authorized': typeof AuthNotAuthorizedRoute
  '/_app/': typeof AppIndexRoute
  '/_app/app-settings/live': typeof AppAppSettingsLiveRoute
  '/_app/backend-settings/barcode': typeof AppBackendSettingsBarcodeRoute
  '/_app/backend-settings/address/jp': typeof AppBackendSettingsAddressJpRoute
  '/_app/backend-settings/address/ph': typeof AppBackendSettingsAddressPhRoute
  '/_app/inventory/customer': typeof AppInventoryCustomerRouteWithChildren
  '/_app/inventory/customer/_modal': typeof AppInventoryCustomerModalRouteWithChildren
  '/_app/inventory/deals': typeof AppInventoryDealsRouteWithChildren
  '/_app/inventory/deals/_modal': typeof AppInventoryDealsModalRouteWithChildren
  '/_app/inventory/live': typeof AppInventoryLiveRouteWithChildren
  '/_app/inventory/live/_modal': typeof AppInventoryLiveModalRouteWithChildren
  '/_app/inventory/product-model': typeof AppInventoryProductModelRouteWithChildren
  '/_app/inventory/product-model/_modal': typeof AppInventoryProductModelModalRouteWithChildren
  '/_app/inventory/product': typeof AppInventoryProductRouteWithChildren
  '/_app/inventory/product/_modal': typeof AppInventoryProductModalRouteWithChildren
  '/_app/inventory/sales-order': typeof AppInventorySalesOrderRouteWithChildren
  '/_app/inventory/sales-order/_modal': typeof AppInventorySalesOrderModalRouteWithChildren
  '/_app/backend-settings/product-import/': typeof AppBackendSettingsProductImportIndexRoute
  '/_app/inventory/category/': typeof AppInventoryCategoryIndexRoute
  '/_app/inventory/purchase-order/': typeof AppInventoryPurchaseOrderIndexRoute
  '/_app/inventory/vendor/': typeof AppInventoryVendorIndexRoute
  '/_app/inventory/purchase-order/supplier-import/page': typeof AppInventoryPurchaseOrderSupplierImportPageRoute
  '/_app/inventory/sales-order/_modal/$salesOrderId': typeof AppInventorySalesOrderModalSalesOrderIdRoute
  '/_app/inventory/sales-order/_modal/app': typeof AppInventorySalesOrderModalAppRoute
  '/_app/inventory/sales-order/_modal/logistic': typeof AppInventorySalesOrderModalLogisticRoute
  '/_app/inventory/sales-order/_modal/payments': typeof AppInventorySalesOrderModalPaymentsRoute
  '/_app/inventory/sales-order/_modal/warehouse': typeof AppInventorySalesOrderModalWarehouseRoute
  '/_app/inventory/customer/_modal/': typeof AppInventoryCustomerModalIndexRoute
  '/_app/inventory/deals/_modal/': typeof AppInventoryDealsModalIndexRoute
  '/_app/inventory/live/_modal/': typeof AppInventoryLiveModalIndexRoute
  '/_app/inventory/product-model/_modal/': typeof AppInventoryProductModelModalIndexRoute
  '/_app/inventory/product/_modal/': typeof AppInventoryProductModalIndexRoute
  '/_app/inventory/sales-order/_modal/': typeof AppInventorySalesOrderModalIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/access-denied'
    | '/plain'
    | '/account'
    | '/admin'
    | '/dashboard'
    | '/login'
    | '/login-success'
    | '/not-authorized'
    | '/'
    | '/app-settings/live'
    | '/backend-settings/barcode'
    | '/backend-settings/address/jp'
    | '/backend-settings/address/ph'
    | '/inventory/customer'
    | '/inventory/deals'
    | '/inventory/live'
    | '/inventory/product-model'
    | '/inventory/product'
    | '/inventory/sales-order'
    | '/backend-settings/product-import'
    | '/inventory/category'
    | '/inventory/purchase-order'
    | '/inventory/vendor'
    | '/inventory/purchase-order/supplier-import/page'
    | '/inventory/sales-order/$salesOrderId'
    | '/inventory/sales-order/app'
    | '/inventory/sales-order/logistic'
    | '/inventory/sales-order/payments'
    | '/inventory/sales-order/warehouse'
    | '/inventory/customer/'
    | '/inventory/deals/'
    | '/inventory/live/'
    | '/inventory/product-model/'
    | '/inventory/product/'
    | '/inventory/sales-order/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/access-denied'
    | '/plain'
    | '/account'
    | '/admin'
    | '/dashboard'
    | '/login'
    | '/login-success'
    | '/not-authorized'
    | '/'
    | '/app-settings/live'
    | '/backend-settings/barcode'
    | '/backend-settings/address/jp'
    | '/backend-settings/address/ph'
    | '/inventory/customer'
    | '/inventory/deals'
    | '/inventory/live'
    | '/inventory/product-model'
    | '/inventory/product'
    | '/inventory/sales-order'
    | '/backend-settings/product-import'
    | '/inventory/category'
    | '/inventory/purchase-order'
    | '/inventory/vendor'
    | '/inventory/purchase-order/supplier-import/page'
    | '/inventory/sales-order/$salesOrderId'
    | '/inventory/sales-order/app'
    | '/inventory/sales-order/logistic'
    | '/inventory/sales-order/payments'
    | '/inventory/sales-order/warehouse'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/access-denied'
    | '/plain'
    | '/_app/account'
    | '/_app/admin'
    | '/_app/dashboard'
    | '/_auth/login'
    | '/_auth/login-success'
    | '/_auth/not-authorized'
    | '/_app/'
    | '/_app/app-settings/live'
    | '/_app/backend-settings/barcode'
    | '/_app/backend-settings/address/jp'
    | '/_app/backend-settings/address/ph'
    | '/_app/inventory/customer'
    | '/_app/inventory/customer/_modal'
    | '/_app/inventory/deals'
    | '/_app/inventory/deals/_modal'
    | '/_app/inventory/live'
    | '/_app/inventory/live/_modal'
    | '/_app/inventory/product-model'
    | '/_app/inventory/product-model/_modal'
    | '/_app/inventory/product'
    | '/_app/inventory/product/_modal'
    | '/_app/inventory/sales-order'
    | '/_app/inventory/sales-order/_modal'
    | '/_app/backend-settings/product-import/'
    | '/_app/inventory/category/'
    | '/_app/inventory/purchase-order/'
    | '/_app/inventory/vendor/'
    | '/_app/inventory/purchase-order/supplier-import/page'
    | '/_app/inventory/sales-order/_modal/$salesOrderId'
    | '/_app/inventory/sales-order/_modal/app'
    | '/_app/inventory/sales-order/_modal/logistic'
    | '/_app/inventory/sales-order/_modal/payments'
    | '/_app/inventory/sales-order/_modal/warehouse'
    | '/_app/inventory/customer/_modal/'
    | '/_app/inventory/deals/_modal/'
    | '/_app/inventory/live/_modal/'
    | '/_app/inventory/product-model/_modal/'
    | '/_app/inventory/product/_modal/'
    | '/_app/inventory/sales-order/_modal/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  AccessDeniedRoute: typeof AccessDeniedRoute
  PlainRoute: typeof PlainRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/plain': {
      id: '/plain'
      path: '/plain'
      fullPath: '/plain'
      preLoaderRoute: typeof PlainRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/access-denied': {
      id: '/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AccessDeniedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/not-authorized': {
      id: '/_auth/not-authorized'
      path: '/not-authorized'
      fullPath: '/not-authorized'
      preLoaderRoute: typeof AuthNotAuthorizedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login-success': {
      id: '/_auth/login-success'
      path: '/login-success'
      fullPath: '/login-success'
      preLoaderRoute: typeof AuthLoginSuccessRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/sales-order': {
      id: '/_app/inventory/sales-order'
      path: '/inventory/sales-order'
      fullPath: '/inventory/sales-order'
      preLoaderRoute: typeof AppInventorySalesOrderRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/product': {
      id: '/_app/inventory/product'
      path: '/inventory/product'
      fullPath: '/inventory/product'
      preLoaderRoute: typeof AppInventoryProductRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/product-model': {
      id: '/_app/inventory/product-model'
      path: '/inventory/product-model'
      fullPath: '/inventory/product-model'
      preLoaderRoute: typeof AppInventoryProductModelRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/live': {
      id: '/_app/inventory/live'
      path: '/inventory/live'
      fullPath: '/inventory/live'
      preLoaderRoute: typeof AppInventoryLiveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/deals': {
      id: '/_app/inventory/deals'
      path: '/inventory/deals'
      fullPath: '/inventory/deals'
      preLoaderRoute: typeof AppInventoryDealsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/customer': {
      id: '/_app/inventory/customer'
      path: '/inventory/customer'
      fullPath: '/inventory/customer'
      preLoaderRoute: typeof AppInventoryCustomerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/backend-settings/barcode': {
      id: '/_app/backend-settings/barcode'
      path: '/backend-settings/barcode'
      fullPath: '/backend-settings/barcode'
      preLoaderRoute: typeof AppBackendSettingsBarcodeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/app-settings/live': {
      id: '/_app/app-settings/live'
      path: '/app-settings/live'
      fullPath: '/app-settings/live'
      preLoaderRoute: typeof AppAppSettingsLiveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/vendor/': {
      id: '/_app/inventory/vendor/'
      path: '/inventory/vendor'
      fullPath: '/inventory/vendor'
      preLoaderRoute: typeof AppInventoryVendorIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/purchase-order/': {
      id: '/_app/inventory/purchase-order/'
      path: '/inventory/purchase-order'
      fullPath: '/inventory/purchase-order'
      preLoaderRoute: typeof AppInventoryPurchaseOrderIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/category/': {
      id: '/_app/inventory/category/'
      path: '/inventory/category'
      fullPath: '/inventory/category'
      preLoaderRoute: typeof AppInventoryCategoryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/backend-settings/product-import/': {
      id: '/_app/backend-settings/product-import/'
      path: '/backend-settings/product-import'
      fullPath: '/backend-settings/product-import'
      preLoaderRoute: typeof AppBackendSettingsProductImportIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/sales-order/_modal': {
      id: '/_app/inventory/sales-order/_modal'
      path: '/inventory/sales-order'
      fullPath: '/inventory/sales-order'
      preLoaderRoute: typeof AppInventorySalesOrderModalRouteImport
      parentRoute: typeof AppInventorySalesOrderRoute
    }
    '/_app/inventory/product/_modal': {
      id: '/_app/inventory/product/_modal'
      path: '/inventory/product'
      fullPath: '/inventory/product'
      preLoaderRoute: typeof AppInventoryProductModalRouteImport
      parentRoute: typeof AppInventoryProductRoute
    }
    '/_app/inventory/product-model/_modal': {
      id: '/_app/inventory/product-model/_modal'
      path: '/inventory/product-model'
      fullPath: '/inventory/product-model'
      preLoaderRoute: typeof AppInventoryProductModelModalRouteImport
      parentRoute: typeof AppInventoryProductModelRoute
    }
    '/_app/inventory/live/_modal': {
      id: '/_app/inventory/live/_modal'
      path: '/inventory/live'
      fullPath: '/inventory/live'
      preLoaderRoute: typeof AppInventoryLiveModalRouteImport
      parentRoute: typeof AppInventoryLiveRoute
    }
    '/_app/inventory/deals/_modal': {
      id: '/_app/inventory/deals/_modal'
      path: '/inventory/deals'
      fullPath: '/inventory/deals'
      preLoaderRoute: typeof AppInventoryDealsModalRouteImport
      parentRoute: typeof AppInventoryDealsRoute
    }
    '/_app/inventory/customer/_modal': {
      id: '/_app/inventory/customer/_modal'
      path: '/inventory/customer'
      fullPath: '/inventory/customer'
      preLoaderRoute: typeof AppInventoryCustomerModalRouteImport
      parentRoute: typeof AppInventoryCustomerRoute
    }
    '/_app/backend-settings/address/ph': {
      id: '/_app/backend-settings/address/ph'
      path: '/backend-settings/address/ph'
      fullPath: '/backend-settings/address/ph'
      preLoaderRoute: typeof AppBackendSettingsAddressPhRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/backend-settings/address/jp': {
      id: '/_app/backend-settings/address/jp'
      path: '/backend-settings/address/jp'
      fullPath: '/backend-settings/address/jp'
      preLoaderRoute: typeof AppBackendSettingsAddressJpRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/sales-order/_modal/': {
      id: '/_app/inventory/sales-order/_modal/'
      path: '/'
      fullPath: '/inventory/sales-order/'
      preLoaderRoute: typeof AppInventorySalesOrderModalIndexRouteImport
      parentRoute: typeof AppInventorySalesOrderModalRoute
    }
    '/_app/inventory/product/_modal/': {
      id: '/_app/inventory/product/_modal/'
      path: '/'
      fullPath: '/inventory/product/'
      preLoaderRoute: typeof AppInventoryProductModalIndexRouteImport
      parentRoute: typeof AppInventoryProductModalRoute
    }
    '/_app/inventory/product-model/_modal/': {
      id: '/_app/inventory/product-model/_modal/'
      path: '/'
      fullPath: '/inventory/product-model/'
      preLoaderRoute: typeof AppInventoryProductModelModalIndexRouteImport
      parentRoute: typeof AppInventoryProductModelModalRoute
    }
    '/_app/inventory/live/_modal/': {
      id: '/_app/inventory/live/_modal/'
      path: '/'
      fullPath: '/inventory/live/'
      preLoaderRoute: typeof AppInventoryLiveModalIndexRouteImport
      parentRoute: typeof AppInventoryLiveModalRoute
    }
    '/_app/inventory/deals/_modal/': {
      id: '/_app/inventory/deals/_modal/'
      path: '/'
      fullPath: '/inventory/deals/'
      preLoaderRoute: typeof AppInventoryDealsModalIndexRouteImport
      parentRoute: typeof AppInventoryDealsModalRoute
    }
    '/_app/inventory/customer/_modal/': {
      id: '/_app/inventory/customer/_modal/'
      path: '/'
      fullPath: '/inventory/customer/'
      preLoaderRoute: typeof AppInventoryCustomerModalIndexRouteImport
      parentRoute: typeof AppInventoryCustomerModalRoute
    }
    '/_app/inventory/sales-order/_modal/warehouse': {
      id: '/_app/inventory/sales-order/_modal/warehouse'
      path: '/warehouse'
      fullPath: '/inventory/sales-order/warehouse'
      preLoaderRoute: typeof AppInventorySalesOrderModalWarehouseRouteImport
      parentRoute: typeof AppInventorySalesOrderModalRoute
    }
    '/_app/inventory/sales-order/_modal/payments': {
      id: '/_app/inventory/sales-order/_modal/payments'
      path: '/payments'
      fullPath: '/inventory/sales-order/payments'
      preLoaderRoute: typeof AppInventorySalesOrderModalPaymentsRouteImport
      parentRoute: typeof AppInventorySalesOrderModalRoute
    }
    '/_app/inventory/sales-order/_modal/logistic': {
      id: '/_app/inventory/sales-order/_modal/logistic'
      path: '/logistic'
      fullPath: '/inventory/sales-order/logistic'
      preLoaderRoute: typeof AppInventorySalesOrderModalLogisticRouteImport
      parentRoute: typeof AppInventorySalesOrderModalRoute
    }
    '/_app/inventory/sales-order/_modal/app': {
      id: '/_app/inventory/sales-order/_modal/app'
      path: '/app'
      fullPath: '/inventory/sales-order/app'
      preLoaderRoute: typeof AppInventorySalesOrderModalAppRouteImport
      parentRoute: typeof AppInventorySalesOrderModalRoute
    }
    '/_app/inventory/sales-order/_modal/$salesOrderId': {
      id: '/_app/inventory/sales-order/_modal/$salesOrderId'
      path: '/$salesOrderId'
      fullPath: '/inventory/sales-order/$salesOrderId'
      preLoaderRoute: typeof AppInventorySalesOrderModalSalesOrderIdRouteImport
      parentRoute: typeof AppInventorySalesOrderModalRoute
    }
    '/_app/inventory/purchase-order/supplier-import/page': {
      id: '/_app/inventory/purchase-order/supplier-import/page'
      path: '/inventory/purchase-order/supplier-import/page'
      fullPath: '/inventory/purchase-order/supplier-import/page'
      preLoaderRoute: typeof AppInventoryPurchaseOrderSupplierImportPageRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppInventoryCustomerModalRouteChildren {
  AppInventoryCustomerModalIndexRoute: typeof AppInventoryCustomerModalIndexRoute
}

const AppInventoryCustomerModalRouteChildren: AppInventoryCustomerModalRouteChildren =
  {
    AppInventoryCustomerModalIndexRoute: AppInventoryCustomerModalIndexRoute,
  }

const AppInventoryCustomerModalRouteWithChildren =
  AppInventoryCustomerModalRoute._addFileChildren(
    AppInventoryCustomerModalRouteChildren,
  )

interface AppInventoryCustomerRouteChildren {
  AppInventoryCustomerModalRoute: typeof AppInventoryCustomerModalRouteWithChildren
}

const AppInventoryCustomerRouteChildren: AppInventoryCustomerRouteChildren = {
  AppInventoryCustomerModalRoute: AppInventoryCustomerModalRouteWithChildren,
}

const AppInventoryCustomerRouteWithChildren =
  AppInventoryCustomerRoute._addFileChildren(AppInventoryCustomerRouteChildren)

interface AppInventoryDealsModalRouteChildren {
  AppInventoryDealsModalIndexRoute: typeof AppInventoryDealsModalIndexRoute
}

const AppInventoryDealsModalRouteChildren: AppInventoryDealsModalRouteChildren =
  {
    AppInventoryDealsModalIndexRoute: AppInventoryDealsModalIndexRoute,
  }

const AppInventoryDealsModalRouteWithChildren =
  AppInventoryDealsModalRoute._addFileChildren(
    AppInventoryDealsModalRouteChildren,
  )

interface AppInventoryDealsRouteChildren {
  AppInventoryDealsModalRoute: typeof AppInventoryDealsModalRouteWithChildren
}

const AppInventoryDealsRouteChildren: AppInventoryDealsRouteChildren = {
  AppInventoryDealsModalRoute: AppInventoryDealsModalRouteWithChildren,
}

const AppInventoryDealsRouteWithChildren =
  AppInventoryDealsRoute._addFileChildren(AppInventoryDealsRouteChildren)

interface AppInventoryLiveModalRouteChildren {
  AppInventoryLiveModalIndexRoute: typeof AppInventoryLiveModalIndexRoute
}

const AppInventoryLiveModalRouteChildren: AppInventoryLiveModalRouteChildren = {
  AppInventoryLiveModalIndexRoute: AppInventoryLiveModalIndexRoute,
}

const AppInventoryLiveModalRouteWithChildren =
  AppInventoryLiveModalRoute._addFileChildren(
    AppInventoryLiveModalRouteChildren,
  )

interface AppInventoryLiveRouteChildren {
  AppInventoryLiveModalRoute: typeof AppInventoryLiveModalRouteWithChildren
}

const AppInventoryLiveRouteChildren: AppInventoryLiveRouteChildren = {
  AppInventoryLiveModalRoute: AppInventoryLiveModalRouteWithChildren,
}

const AppInventoryLiveRouteWithChildren =
  AppInventoryLiveRoute._addFileChildren(AppInventoryLiveRouteChildren)

interface AppInventoryProductModelModalRouteChildren {
  AppInventoryProductModelModalIndexRoute: typeof AppInventoryProductModelModalIndexRoute
}

const AppInventoryProductModelModalRouteChildren: AppInventoryProductModelModalRouteChildren =
  {
    AppInventoryProductModelModalIndexRoute:
      AppInventoryProductModelModalIndexRoute,
  }

const AppInventoryProductModelModalRouteWithChildren =
  AppInventoryProductModelModalRoute._addFileChildren(
    AppInventoryProductModelModalRouteChildren,
  )

interface AppInventoryProductModelRouteChildren {
  AppInventoryProductModelModalRoute: typeof AppInventoryProductModelModalRouteWithChildren
}

const AppInventoryProductModelRouteChildren: AppInventoryProductModelRouteChildren =
  {
    AppInventoryProductModelModalRoute:
      AppInventoryProductModelModalRouteWithChildren,
  }

const AppInventoryProductModelRouteWithChildren =
  AppInventoryProductModelRoute._addFileChildren(
    AppInventoryProductModelRouteChildren,
  )

interface AppInventoryProductModalRouteChildren {
  AppInventoryProductModalIndexRoute: typeof AppInventoryProductModalIndexRoute
}

const AppInventoryProductModalRouteChildren: AppInventoryProductModalRouteChildren =
  {
    AppInventoryProductModalIndexRoute: AppInventoryProductModalIndexRoute,
  }

const AppInventoryProductModalRouteWithChildren =
  AppInventoryProductModalRoute._addFileChildren(
    AppInventoryProductModalRouteChildren,
  )

interface AppInventoryProductRouteChildren {
  AppInventoryProductModalRoute: typeof AppInventoryProductModalRouteWithChildren
}

const AppInventoryProductRouteChildren: AppInventoryProductRouteChildren = {
  AppInventoryProductModalRoute: AppInventoryProductModalRouteWithChildren,
}

const AppInventoryProductRouteWithChildren =
  AppInventoryProductRoute._addFileChildren(AppInventoryProductRouteChildren)

interface AppInventorySalesOrderModalRouteChildren {
  AppInventorySalesOrderModalSalesOrderIdRoute: typeof AppInventorySalesOrderModalSalesOrderIdRoute
  AppInventorySalesOrderModalAppRoute: typeof AppInventorySalesOrderModalAppRoute
  AppInventorySalesOrderModalLogisticRoute: typeof AppInventorySalesOrderModalLogisticRoute
  AppInventorySalesOrderModalPaymentsRoute: typeof AppInventorySalesOrderModalPaymentsRoute
  AppInventorySalesOrderModalWarehouseRoute: typeof AppInventorySalesOrderModalWarehouseRoute
  AppInventorySalesOrderModalIndexRoute: typeof AppInventorySalesOrderModalIndexRoute
}

const AppInventorySalesOrderModalRouteChildren: AppInventorySalesOrderModalRouteChildren =
  {
    AppInventorySalesOrderModalSalesOrderIdRoute:
      AppInventorySalesOrderModalSalesOrderIdRoute,
    AppInventorySalesOrderModalAppRoute: AppInventorySalesOrderModalAppRoute,
    AppInventorySalesOrderModalLogisticRoute:
      AppInventorySalesOrderModalLogisticRoute,
    AppInventorySalesOrderModalPaymentsRoute:
      AppInventorySalesOrderModalPaymentsRoute,
    AppInventorySalesOrderModalWarehouseRoute:
      AppInventorySalesOrderModalWarehouseRoute,
    AppInventorySalesOrderModalIndexRoute:
      AppInventorySalesOrderModalIndexRoute,
  }

const AppInventorySalesOrderModalRouteWithChildren =
  AppInventorySalesOrderModalRoute._addFileChildren(
    AppInventorySalesOrderModalRouteChildren,
  )

interface AppInventorySalesOrderRouteChildren {
  AppInventorySalesOrderModalRoute: typeof AppInventorySalesOrderModalRouteWithChildren
}

const AppInventorySalesOrderRouteChildren: AppInventorySalesOrderRouteChildren =
  {
    AppInventorySalesOrderModalRoute:
      AppInventorySalesOrderModalRouteWithChildren,
  }

const AppInventorySalesOrderRouteWithChildren =
  AppInventorySalesOrderRoute._addFileChildren(
    AppInventorySalesOrderRouteChildren,
  )

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppAdminRoute: typeof AppAdminRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAppSettingsLiveRoute: typeof AppAppSettingsLiveRoute
  AppBackendSettingsBarcodeRoute: typeof AppBackendSettingsBarcodeRoute
  AppBackendSettingsAddressJpRoute: typeof AppBackendSettingsAddressJpRoute
  AppBackendSettingsAddressPhRoute: typeof AppBackendSettingsAddressPhRoute
  AppInventoryCustomerRoute: typeof AppInventoryCustomerRouteWithChildren
  AppInventoryDealsRoute: typeof AppInventoryDealsRouteWithChildren
  AppInventoryLiveRoute: typeof AppInventoryLiveRouteWithChildren
  AppInventoryProductModelRoute: typeof AppInventoryProductModelRouteWithChildren
  AppInventoryProductRoute: typeof AppInventoryProductRouteWithChildren
  AppInventorySalesOrderRoute: typeof AppInventorySalesOrderRouteWithChildren
  AppBackendSettingsProductImportIndexRoute: typeof AppBackendSettingsProductImportIndexRoute
  AppInventoryCategoryIndexRoute: typeof AppInventoryCategoryIndexRoute
  AppInventoryPurchaseOrderIndexRoute: typeof AppInventoryPurchaseOrderIndexRoute
  AppInventoryVendorIndexRoute: typeof AppInventoryVendorIndexRoute
  AppInventoryPurchaseOrderSupplierImportPageRoute: typeof AppInventoryPurchaseOrderSupplierImportPageRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppAdminRoute: AppAdminRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppIndexRoute: AppIndexRoute,
  AppAppSettingsLiveRoute: AppAppSettingsLiveRoute,
  AppBackendSettingsBarcodeRoute: AppBackendSettingsBarcodeRoute,
  AppBackendSettingsAddressJpRoute: AppBackendSettingsAddressJpRoute,
  AppBackendSettingsAddressPhRoute: AppBackendSettingsAddressPhRoute,
  AppInventoryCustomerRoute: AppInventoryCustomerRouteWithChildren,
  AppInventoryDealsRoute: AppInventoryDealsRouteWithChildren,
  AppInventoryLiveRoute: AppInventoryLiveRouteWithChildren,
  AppInventoryProductModelRoute: AppInventoryProductModelRouteWithChildren,
  AppInventoryProductRoute: AppInventoryProductRouteWithChildren,
  AppInventorySalesOrderRoute: AppInventorySalesOrderRouteWithChildren,
  AppBackendSettingsProductImportIndexRoute:
    AppBackendSettingsProductImportIndexRoute,
  AppInventoryCategoryIndexRoute: AppInventoryCategoryIndexRoute,
  AppInventoryPurchaseOrderIndexRoute: AppInventoryPurchaseOrderIndexRoute,
  AppInventoryVendorIndexRoute: AppInventoryVendorIndexRoute,
  AppInventoryPurchaseOrderSupplierImportPageRoute:
    AppInventoryPurchaseOrderSupplierImportPageRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLoginSuccessRoute: typeof AuthLoginSuccessRoute
  AuthNotAuthorizedRoute: typeof AuthNotAuthorizedRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthLoginSuccessRoute: AuthLoginSuccessRoute,
  AuthNotAuthorizedRoute: AuthNotAuthorizedRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  AccessDeniedRoute: AccessDeniedRoute,
  PlainRoute: PlainRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
